export const WEAPONS = Object.freeze({
  wood_sword: Object.freeze({ type: 'sword', id: 'wood_sword', name: 'Wood Sword', damage: 10 }),
  stone_sword: Object.freeze({ type: 'sword', id: 'stone_sword', name: 'Stone Sword', damage: 15 }),
  bone_sword: Object.freeze({ type: 'sword', id: 'bone_sword', name: 'Bone Sword', damage: 20 }),
  gravekeeper_blade: Object.freeze({
    type: 'sword',
    id: 'gravekeeper_blade',
    name: "Gravekeeper's Blade",
    damage: 20
  }),
  iron_sword: Object.freeze({ type: 'sword', id: 'iron_sword', name: 'Iron Sword', damage: 20 }),
  diamond_sword: Object.freeze({ type: 'sword', id: 'diamond_sword', name: 'Diamond Sword', damage: 30 }),
  ember_sword: Object.freeze({ type: 'sword', id: 'ember_sword', name: 'Ember Sword', damage: 40 }),
  legendary_sword: Object.freeze({ type: 'sword', id: 'legendary_sword', name: 'Legendary Sword', damage: 50 }),
  royal_sword: Object.freeze({ type: 'sword', id: 'royal_sword', name: 'Royal Sunblade', damage: 65 })
})

export function getWeapon(id) {
  return WEAPONS[id] || null
}

export const ITEMS = {
  // Swords
  WOOD_SWORD: WEAPONS.wood_sword,
  STONE_SWORD: WEAPONS.stone_sword,
  GRAVEKEEPER_BLADE: WEAPONS.gravekeeper_blade,
  IRON_SWORD: WEAPONS.iron_sword,
  DIAMOND_SWORD: WEAPONS.diamond_sword,
  LEGENDARY_SWORD: WEAPONS.legendary_sword,
  ROYAL_SWORD: WEAPONS.royal_sword,
  
  // Food
  APPLE: { type: 'food', id: 'apple', name: 'Apple', hungerRestore: 15 },
  BREAD: { type: 'food', id: 'bread', name: 'Bread', hungerRestore: 25 },
  COOKED_MEAT: { type: 'food', id: 'cooked_meat', name: 'Cooked Meat', hungerRestore: 40 },
  STEAK: { type: 'food', id: 'steak', name: 'Steak', hungerRestore: 50 },
  GOLDEN_APPLE: { type: 'food', id: 'golden_apple', name: 'Golden Apple', hungerRestore: 100 },
  ROTTEN_FLESH: { type: 'food', id: 'rotten_flesh', name: 'Rotten Flesh', hungerRestore: 5 },
  
  // Potions
  HEALTH_POTION: { type: 'potion', id: 'health_potion', name: 'Health Potion', healAmount: 50 },
  
  // Armor
  LEATHER_ARMOR: { type: 'armor', id: 'leather_armor', name: 'Leather Armor', defense: 3 },
  IRON_ARMOR: { type: 'armor', id: 'iron_armor', name: 'Iron Armor', defense: 5 },
  DIAMOND_ARMOR: { type: 'armor', id: 'diamond_armor', name: 'Diamond Armor', defense: 10 },
  
  // Placeable
  TORCH: { type: 'torch', id: 'torch', name: 'Torch', blockType: 16 },
  
  // Misc items
  BONE: { type: 'item', id: 'bone', name: 'Bone' },
  STRING: { type: 'item', id: 'string', name: 'String' },
  SPIDER_EYE: { type: 'item', id: 'spider_eye', name: 'Spider Eye' },
  WOLF_PELT: { type: 'item', id: 'wolf_pelt', name: 'Wolf Pelt' },
  MAGIC_CRYSTAL: { type: 'item', id: 'magic_crystal', name: 'Magic Crystal' }
}

export function getItemIcon(itemType) {
  const icons = {
    sword: '🗡️',
    food: '🍖',
    potion: '🧪',
    armor: '🛡️',
    block: '🧱',
    torch: '🔥',
    item: '📦'
  }
  return icons[itemType] || '❓'
}
